"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6238],{

/***/ 78516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Button_Button; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/CommonComponents/Button/Button.styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 6rem;\n  border-radius: ",
        "px;\n  outline: none;\n  border: none;\n  padding: 0.75rem 1rem;\n  cursor: pointer;\n  &.btn__primary {\n    background: ",
        ";\n    color: ",
        ";\n    font-size: ",
        "rem;\n    font-family: ",
        ";\n    font-weight: ",
        ";\n  }\n  &.btn__primary:hover {\n    background: ",
        ";\n    transition: background 0.5s ease-in-out;\n  }\n  &.btn__secondary {\n    background: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n    font-size: ",
        "rem;\n    font-family: ",
        ";\n    font-weight: ",
        ";\n  }\n  &.btn__secondary:hover {\n    background: ",
        ";\n    transition: background 0.5s ease-in-out;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ButtonComponent = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "ButtonComponent",
    componentId: "sc-7bbccc7b-0"
})(_templateObject(), function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.roundness) || 0;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.backgroundColor;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.color;
}, function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.textFontSize) || 1;
}, function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.fontFamily) || "Arial";
}, function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.fontWeight) || "500";
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.backgroundHoverColor;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.backgroundColor;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.borderColor;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.borderColor;
}, function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.textFontSize) || 1;
}, function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.fontFamily) || "Arial";
}, function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.fontWeight) || "500";
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.borderColor;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.color;
});

// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/btnUtils.js
var btnUtils = __webpack_require__(993080);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/CommonComponents/Button/Button.js



var Button = function(props) {
    var ref, ref1, ref2;
    return (props === null || props === void 0 ? void 0 : (ref = props.btnData) === null || ref === void 0 ? void 0 : ref.btnText) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonComponent, {
        className: "btn__".concat(props === null || props === void 0 ? void 0 : (ref1 = props.btnData) === null || ref1 === void 0 ? void 0 : ref1.type),
        primaryButton: props === null || props === void 0 ? void 0 : props.primaryButton,
        secondaryButton: props === null || props === void 0 ? void 0 : props.secondaryButton,
        onClick: function() {
            var ref;
            (0,btnUtils/* btnActionHandler */.c)(props === null || props === void 0 ? void 0 : (ref = props.btnData) === null || ref === void 0 ? void 0 : ref.actions, props === null || props === void 0 ? void 0 : props.callback);
            (props === null || props === void 0 ? void 0 : props.handleClose) && (props === null || props === void 0 ? void 0 : props.handleClose());
        },
        children: props === null || props === void 0 ? void 0 : (ref2 = props.btnData) === null || ref2 === void 0 ? void 0 : ref2.btnText
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var Button_Button = (Button);


/***/ }),

/***/ 458252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);

var Description = function(props) {
    var ref;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
        onClick: function(e) {
            var ref, ref1, ref2;
            e.stopPropagation();
            props === null || props === void 0 ? void 0 : (ref = props.handleEditText) === null || ref === void 0 ? void 0 : ref.call(props);
            props === null || props === void 0 ? void 0 : (ref2 = props.getInputPreFilledValue) === null || ref2 === void 0 ? void 0 : ref2.call(props, (ref1 = props.descriptionData) === null || ref1 === void 0 ? void 0 : ref1.text);
        },
        className: "Description",
        children: (ref = props.descriptionData) === null || ref === void 0 ? void 0 : ref.text
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Description);


/***/ }),

/***/ 192578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);

var Heading = function(props) {
    var ref;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
        className: "Heading",
        children: props === null || props === void 0 ? void 0 : (ref = props.headingData) === null || ref === void 0 ? void 0 : ref.text
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Heading);


/***/ }),

/***/ 216238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ MiddleBody_Maps_ModernMiddleBodyMaps; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./src/components/WidgetMaker/utils/common.ts
var common = __webpack_require__(737179);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/getStylesConfig.js
var getStylesConfig = __webpack_require__(842757);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/MiddleBody/MiddleBody_Maps/ModernMiddleBodyMaps.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  background: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var MapMiddleBodyParentContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MapMiddleBodyParentContainer",
    componentId: "sc-d127f7aa-0"
})(_templateObject(), function(props) {
    return props === null || props === void 0 ? void 0 : props.themeBackground;
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/common.js + 9 modules
var utils_common = __webpack_require__(720901);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/MiddleBody/MiddleBody_Maps/Layout/ModernMiddleBodyLayout1/ModernMiddleBodyLayout1.styles.js

function ModernMiddleBodyLayout1_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  &.map1_container {\n    display: flex;\n    flex-direction: column;\n\n    &.map1_container > .top_section {\n      display: flex;\n      flex: 0;\n    }\n    &.map1_container > .bottom_section {\n      flex: 1;\n    }\n    &.map1_container > .top_section > .top_section_left {\n      display: flex;\n      flex-direction: column;\n      gap: 1rem;\n      flex: 1;\n    }\n    &.map1_container > .top_section > .top_section_left h1 {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: flex-start;\n      width: 100%;\n      margin: 0;\n      color: ",
        ";\n      font-family: ",
        ";\n      text-align: ",
        ";\n      overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n      overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n    }\n    &.map1_container > .top_section > .top_section_left p {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: flex-start;\n      width: 100%;\n      font-style: normal;\n      margin: 0;\n      color: ",
        ";\n      text-align: ",
        ";\n      font-family: ",
        ";\n      opacity: ",
        ";\n      overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n      overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n    }\n    &.map1_container > .top_section > .top_section_right {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      gap: 1rem;\n      align-self: center;\n    }\n    @media screen and (min-width: 768px) {\n      padding: 4rem;\n      gap: 2rem;\n      &.map1_container > .top_section {\n        gap: 4rem;\n        flex-direction: row;\n      }\n      &.map1_container > .top_section > .top_section_left h1 {\n        font-size: ",
        ";\n        font-weight: ",
        ";\n        line-height: 3.875rem;\n      }\n      &.map1_container > .top_section > .top_section_left p {\n        font-size: ",
        ";\n        font-weight: ",
        ";\n        line-height: 1.75rem;\n      }\n      &.map1_container > .bottom_section iframe {\n        height: 564px;\n      }\n    }\n    @media screen and (max-width: 767px) {\n      padding: 2rem 1rem;\n      gap: 2.5rem;\n      &.map1_container > .top_section {\n        gap: 1rem;\n        flex-direction: column;\n      }\n      &.map1_container > .top_section > .top_section_left h1 {\n        font-size: 1.5rem;\n        line-height: normal;\n      }\n      &.map1_container > .top_section > .top_section_left p {\n        font-size: 0.875rem;\n        line-height: normal;\n      }\n      &.map1_container > .top_section > .top_section_right {\n        width: 100%;\n      }\n      &.map1_container > .top_section > .top_section_right button {\n        width: 100%;\n      }\n      &.map1_container > .bottom_section iframe {\n        height: 226px;\n      }\n    }\n  }\n\n  &.map4_container {\n    display: flex;\n    flex-direction: column;\n\n    &.map4_container > .top_section {\n      display: flex;\n      flex: 0;\n    }\n    &.map4_container > .bottom_section {\n      flex: 1;\n    }\n    &.map4_container > .top_section > .top_section_left {\n      display: flex;\n      flex-direction: column;\n      gap: 1rem;\n      flex: 1;\n    }\n    &.map4_container > .top_section > .top_section_left h1 {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: flex-start;\n      width: 100%;\n      margin: 0;\n      color: ",
        ";\n      font-family: ",
        ";\n      text-align: ",
        ";\n      overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n      overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n    }\n    &.map4_container > .top_section > .top_section_left p {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: flex-start;\n      width: 100%;\n      font-style: normal;\n      margin: 0;\n      color: ",
        ";\n      text-align: ",
        ";\n      font-family: ",
        ";\n      opacity: ",
        ";\n      overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n      overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n    }\n    &.map4_container > .top_section > .top_section_right {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      gap: 1rem;\n      align-self: center;\n    }\n    @media screen and (min-width: 768px) {\n      padding: 4rem 0;\n      gap: 2rem;\n      &.map4_container > .top_section {\n        gap: 4rem;\n        flex-direction: row;\n        padding: 0 4rem;\n      }\n      &.map4_container > .top_section > .top_section_left h1 {\n        font-size: ",
        ";\n        font-weight: ",
        ";\n        line-height: 3.875rem;\n      }\n      &.map4_container > .top_section > .top_section_left p {\n        font-size: ",
        ";\n        font-weight: ",
        ";\n        line-height: 1.75rem;\n      }\n      &.map4_container > .bottom_section iframe {\n        height: 564px;\n      }\n    }\n    @media screen and (max-width: 767px) {\n      padding: 2rem 0;\n      gap: 2.5rem;\n      &.map4_container > .top_section {\n        gap: 1rem;\n        flex-direction: column;\n        padding: 0 1rem;\n      }\n      &.map4_container > .top_section > .top_section_left h1 {\n        font-size: 1.5rem;\n        line-height: normal;\n      }\n      &.map4_container > .top_section > .top_section_left p {\n        font-size: 0.875rem;\n        line-height: normal;\n      }\n      &.map4_container > .top_section > .top_section_right {\n        width: 100%;\n      }\n      &.map4_container > .top_section > .top_section_right button {\n        width: 100%;\n      }\n      &.map4_container > .bottom_section iframe {\n        height: 226px;\n      }\n    }\n  }\n"
    ]);
    ModernMiddleBodyLayout1_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ModernMiddleBodyLayout1Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ModernMiddleBodyLayout1Wrapper",
    componentId: "sc-ca9c358f-0"
})(ModernMiddleBodyLayout1_styles_templateObject(), function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontFamily) || "Arial";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.textAlign) || "left";
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.textAlign) || "left";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontFamily) || "Arial";
}, utils_common/* BODY_COLOR_OPACITY */.ur, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontSize) || "3.25rem";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontWeight) || "500";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontSize) || "1.25rem";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontWeight) || "400";
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontFamily) || "Arial";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.textAlign) || "left";
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.textAlign) || "left";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontFamily) || "Arial";
}, utils_common/* BODY_COLOR_OPACITY */.ur, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontSize) || "3.25rem";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontWeight) || "500";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontSize) || "1.25rem";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontWeight) || "400";
});

// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/CommonComponents/Heading/Heading.js
var Heading = __webpack_require__(192578);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/CommonComponents/Button/Button.js + 1 modules
var Button = __webpack_require__(78516);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/CommonComponents/Description/Description.js
var Description = __webpack_require__(458252);
// EXTERNAL MODULE: ./src/utils/getGoogleMapUrl.js
var getGoogleMapUrl = __webpack_require__(448863);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/MiddleBody/MiddleBody_Maps/RenderMap.js



var RenderMap = function(props) {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("iframe", {
        width: "100%",
        title: "Address",
        loading: "lazy",
        src: (0,getGoogleMapUrl/* getGoogleMapUrl */.D)(props === null || props === void 0 ? void 0 : props.latitude, props === null || props === void 0 ? void 0 : props.longitude),
        style: {
            background: utils_common/* FALLBACK_COLOR */.R3
        }
    });
};
/* harmony default export */ var MiddleBody_Maps_RenderMap = (RenderMap);

;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/MiddleBody/MiddleBody_Maps/Layout/ModernMiddleBodyLayout1/ModernMiddleBodyLayout1.js








var ModernMiddleBodyLayout1 = function(props) {
    var ref, ref1, ref2, ref3, ref4;
    var middleBodyMapState = props.middleBodyMapState, propStyle = props.propStyle, mapLatLong = props.mapLatLong;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModernMiddleBodyLayout1Wrapper, {
        className: "map".concat(middleBodyMapState === null || middleBodyMapState === void 0 ? void 0 : (ref = middleBodyMapState.mapData) === null || ref === void 0 ? void 0 : ref.mapType, "_container"),
        themeStyle: propStyle,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "top_section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "top_section_left",
                        children: [
                            (middleBodyMapState === null || middleBodyMapState === void 0 ? void 0 : (ref1 = middleBodyMapState.heading) === null || ref1 === void 0 ? void 0 : ref1.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                headingData: middleBodyMapState === null || middleBodyMapState === void 0 ? void 0 : middleBodyMapState.heading
                            }),
                            (middleBodyMapState === null || middleBodyMapState === void 0 ? void 0 : (ref2 = middleBodyMapState.description) === null || ref2 === void 0 ? void 0 : ref2.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Description/* default */.Z, {
                                descriptionData: middleBodyMapState === null || middleBodyMapState === void 0 ? void 0 : middleBodyMapState.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "top_section_right",
                        children: middleBodyMapState === null || middleBodyMapState === void 0 ? void 0 : (ref3 = middleBodyMapState.button) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.content) === null || ref4 === void 0 ? void 0 : ref4.map(function(btnData, idx) {
                            var ref, ref1, ref2;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                type: middleBodyMapState === null || middleBodyMapState === void 0 ? void 0 : (ref = middleBodyMapState.button) === null || ref === void 0 ? void 0 : ref.type,
                                btnData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, btnData), {
                                    actions: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, btnData === null || btnData === void 0 ? void 0 : btnData.actions), {
                                        handler: middleBodyMapState === null || middleBodyMapState === void 0 ? void 0 : (ref1 = middleBodyMapState.mapData) === null || ref1 === void 0 ? void 0 : ref1.url
                                    })
                                }),
                                primaryButton: propStyle === null || propStyle === void 0 ? void 0 : propStyle.buttonPrimary,
                                secondaryButton: propStyle === null || propStyle === void 0 ? void 0 : propStyle.buttonSecondary,
                                handler: middleBodyMapState === null || middleBodyMapState === void 0 ? void 0 : (ref2 = middleBodyMapState.mapData) === null || ref2 === void 0 ? void 0 : ref2.url
                            }, (btnData === null || btnData === void 0 ? void 0 : btnData.id) || idx);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bottom_section",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleBody_Maps_RenderMap, (0,_object_spread/* default */.Z)({}, mapLatLong))
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/MiddleBody/MiddleBody_Maps/Layout/ModernMiddleBodyLayout2/ModernMiddleBodyLayout2.styles.js

function ModernMiddleBodyLayout2_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  &.map2_container {\n    display: flex;\n\n    &.map2_container > .left_section {\n      display: flex;\n      flex-direction: column;\n    }\n    &.map2_container > .right_section {\n    }\n    &.map2_container > .left_section > .left_section_top {\n      display: flex;\n      flex-direction: column;\n      gap: 1rem;\n    }\n    &.map2_container > .left_section > .left_section_top h1 {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: flex-start;\n      width: 100%;\n      margin: 0;\n      color: ",
        ";\n      font-family: ",
        ";\n      text-align: ",
        ";\n      overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n      overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n    }\n    &.map2_container > .left_section > .left_section_top p {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: flex-start;\n      width: 100%;\n      font-style: normal;\n      margin: 0;\n      color: ",
        ";\n      text-align: ",
        ";\n      font-family: ",
        ";\n      opacity: ",
        ";\n      overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n      overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n    }\n    &.map2_container > .left_section > .left_section_bottom {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      gap: 1rem;\n      align-self: flex-start;\n    }\n    @media screen and (min-width: 768px) {\n      padding: 4rem;\n      gap: 4rem;\n      &.map2_container > .left_section {\n        gap: 4rem;\n        width: 50%;\n        align-self: center;\n      }\n      &.map2_container > .right_section {\n        width: 50%;\n      }\n      &.map2_container > .left_section > .left_section_top h1 {\n        font-size: ",
        ";\n        font-weight: ",
        ";\n        line-height: 3.875rem;\n      }\n      &.map2_container > .left_section > .left_section_top p {\n        font-size: ",
        ";\n        font-weight: ",
        ";\n        line-height: 1.75rem;\n      }\n      &.map2_container > .right_section iframe {\n        height: 564px;\n      }\n    }\n    @media screen and (max-width: 767px) {\n      padding: 2rem 1rem;\n      gap: 2.5rem;\n      flex-direction: column;\n      &.map2_container > .left_section {\n        width: 100%;\n        gap: 1rem;\n      }\n      &.map2_container > .right_section {\n        width: 100%;\n      }\n      &.map2_container > .left_section > .left_section_top h1 {\n        font-size: 1.5rem;\n        line-height: normal;\n      }\n      &.map2_container > .left_section > .left_section_top p {\n        font-size: 0.875rem;\n        line-height: normal;\n      }\n      &.map2_container > .left_section > .left_section_bottom {\n        width: 100%;\n      }\n      &.map2_container > .left_section > .left_section_bottom button {\n        width: 100%;\n      }\n      &.map2_container > .right_section iframe {\n        height: 226px;\n      }\n    }\n  }\n\n  &.map3_container {\n    display: flex;\n\n    &.map3_container > .left_section {\n      display: flex;\n      flex-direction: column;\n    }\n    &.map3_container > .right_section {\n    }\n    &.map3_container > .left_section > .left_section_top {\n      display: flex;\n      flex-direction: column;\n      gap: 1rem;\n    }\n    &.map3_container > .left_section > .left_section_top h1 {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: flex-start;\n      width: 100%;\n      margin: 0;\n      color: ",
        ";\n      font-family: ",
        ";\n      text-align: ",
        ";\n      overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n      overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n    }\n    &.map3_container > .left_section > .left_section_top p {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: flex-start;\n      width: 100%;\n      font-style: normal;\n      margin: 0;\n      color: ",
        ";\n      text-align: ",
        ";\n      font-family: ",
        ";\n      opacity: ",
        ";\n      overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n      overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n    }\n    &.map3_container > .left_section > .left_section_bottom {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      gap: 1rem;\n      align-self: flex-start;\n    }\n    @media screen and (min-width: 768px) {\n      gap: 4rem;\n      &.map3_container > .left_section {\n        gap: 4rem;\n        width: 50%;\n        align-self: center;\n        padding: 0 0 0 4rem;\n      }\n      &.map3_container > .right_section {\n        width: 50%;\n      }\n      &.map3_container > .left_section > .left_section_top h1 {\n        font-size: ",
        ";\n        font-weight: ",
        ";\n        line-height: 3.875rem;\n      }\n      &.map3_container > .left_section > .left_section_top p {\n        font-size: ",
        ";\n        font-weight: ",
        ";\n        line-height: 1.75rem;\n      }\n      &.map3_container > .right_section iframe {\n        height: 564px;\n      }\n    }\n    @media screen and (max-width: 767px) {\n      padding: 2rem 0;\n      gap: 2.5rem;\n      flex-direction: column;\n      &.map3_container > .left_section {\n        width: 100%;\n        gap: 1rem;\n        padding: 0 1rem;\n      }\n      &.map3_container > .right_section {\n        width: 100%;\n      }\n      &.map3_container > .left_section > .left_section_top h1 {\n        font-size: 1.5rem;\n        line-height: normal;\n      }\n      &.map3_container > .left_section > .left_section_top p {\n        font-size: 0.875rem;\n        line-height: normal;\n      }\n      &.map3_container > .left_section > .left_section_bottom {\n        width: 100%;\n      }\n      &.map3_container > .left_section > .left_section_bottom button {\n        width: 100%;\n      }\n      &.map3_container > .right_section iframe {\n        height: 226px;\n      }\n    }\n  }\n"
    ]);
    ModernMiddleBodyLayout2_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ModernMiddleBodyLayout2Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ModernMiddleBodyLayout2Wrapper",
    componentId: "sc-675cb8ee-0"
})(ModernMiddleBodyLayout2_styles_templateObject(), function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontFamily) || "Arial";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.textAlign) || "left";
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.textAlign) || "left";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontFamily) || "Arial";
}, utils_common/* BODY_COLOR_OPACITY */.ur, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontSize) || "3.25rem";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontWeight) || "500";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontSize) || "1.25rem";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontWeight) || "400";
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontFamily) || "Arial";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.textAlign) || "left";
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.textAlign) || "left";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontFamily) || "Arial";
}, utils_common/* BODY_COLOR_OPACITY */.ur, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontSize) || "3.25rem";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontWeight) || "500";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontSize) || "1.25rem";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontWeight) || "400";
});

;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/MiddleBody/MiddleBody_Maps/Layout/ModernMiddleBodyLayout2/ModernMiddleBodyLayout2.js








var ModernMiddleBodyLayout2 = function(props) {
    var ref, ref1, ref2, ref3, ref4;
    var middleBodyMapState = props.middleBodyMapState, propStyle = props.propStyle, mapLatLong = props.mapLatLong;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModernMiddleBodyLayout2Wrapper, {
        className: "map".concat(middleBodyMapState === null || middleBodyMapState === void 0 ? void 0 : (ref = middleBodyMapState.mapData) === null || ref === void 0 ? void 0 : ref.mapType, "_container"),
        themeStyle: propStyle,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "left_section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "left_section_top",
                        children: [
                            (middleBodyMapState === null || middleBodyMapState === void 0 ? void 0 : (ref1 = middleBodyMapState.heading) === null || ref1 === void 0 ? void 0 : ref1.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                headingData: middleBodyMapState === null || middleBodyMapState === void 0 ? void 0 : middleBodyMapState.heading
                            }),
                            (middleBodyMapState === null || middleBodyMapState === void 0 ? void 0 : (ref2 = middleBodyMapState.description) === null || ref2 === void 0 ? void 0 : ref2.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Description/* default */.Z, {
                                descriptionData: middleBodyMapState === null || middleBodyMapState === void 0 ? void 0 : middleBodyMapState.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "left_section_bottom",
                        children: middleBodyMapState === null || middleBodyMapState === void 0 ? void 0 : (ref3 = middleBodyMapState.button) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.content) === null || ref4 === void 0 ? void 0 : ref4.map(function(btnData, idx) {
                            var ref, ref1, ref2;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                type: middleBodyMapState === null || middleBodyMapState === void 0 ? void 0 : (ref = middleBodyMapState.button) === null || ref === void 0 ? void 0 : ref.type,
                                btnData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, btnData), {
                                    actions: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, btnData === null || btnData === void 0 ? void 0 : btnData.actions), {
                                        handler: middleBodyMapState === null || middleBodyMapState === void 0 ? void 0 : (ref1 = middleBodyMapState.mapData) === null || ref1 === void 0 ? void 0 : ref1.url
                                    })
                                }),
                                primaryButton: propStyle === null || propStyle === void 0 ? void 0 : propStyle.buttonPrimary,
                                secondaryButton: propStyle === null || propStyle === void 0 ? void 0 : propStyle.buttonSecondary,
                                handler: middleBodyMapState === null || middleBodyMapState === void 0 ? void 0 : (ref2 = middleBodyMapState.mapData) === null || ref2 === void 0 ? void 0 : ref2.url
                            }, (btnData === null || btnData === void 0 ? void 0 : btnData.id) || idx);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "right_section",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleBody_Maps_RenderMap, (0,_object_spread/* default */.Z)({}, mapLatLong))
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/MiddleBody/MiddleBody_Maps/Layout/ModernMiddleBodyLayout3/ModernMiddleBodyLayout3.styles.js

function ModernMiddleBodyLayout3_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  &.map5_container {\n    display: flex;\n    flex-direction: column;\n\n    &.map5_container > .top_section {\n      display: flex;\n      flex-direction: column;\n      flex: 0;\n      justify-content: center;\n      align-items: center;\n      width: 100%;\n      gap: 1rem;\n    }\n    &.map5_container > .bottom_section {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n    }\n    &.map5_container > .top_section > h1 {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: center;\n      width: 100%;\n      margin: 0;\n      color: ",
        ";\n      font-family: ",
        ";\n      text-align: ",
        ";\n      overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n      overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n    }\n    &.map5_container > .top_section > p {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: center;\n      width: 100%;\n      font-style: normal;\n      margin: 0;\n      color: ",
        ";\n      text-align: ",
        ";\n      font-family: ",
        ";\n      opacity: ",
        ";\n      overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n      overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n    }\n    &.map5_container > .bottom_section > .bottom_section_bottom {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      gap: 1rem;\n      align-self: center;\n    }\n    @media screen and (min-width: 768px) {\n      padding: 4rem;\n      gap: 2rem;\n      &.map5_container > .top_section > h1 {\n        font-size: ",
        ";\n        font-weight: ",
        ";\n        line-height: 3.875rem;\n      }\n      &.map5_container > .top_section > p {\n        font-size: ",
        ";\n        font-weight: ",
        ";\n        line-height: 1.75rem;\n      }\n      &.map5_container > .bottom_section {\n        gap: 4rem;\n      }\n      &.map5_container > .bottom_section iframe {\n        height: 564px;\n      }\n    }\n    @media screen and (max-width: 767px) {\n      padding: 2rem 1rem;\n      gap: 1rem;\n      &.map5_container > .top_section > h1 {\n        font-size: 1.5rem;\n        line-height: normal;\n      }\n      &.map5_container > .top_section > p {\n        font-size: 0.875rem;\n        line-height: normal;\n      }\n      &.map5_container > .bottom_section {\n        gap: 1rem;\n      }\n      &.map5_container > .bottom_section > .bottom_section_bottom {\n        width: 100%;\n      }\n      &.map5_container > .bottom_section > .bottom_section_bottom button {\n        width: 100%;\n      }\n      &.map5_container > .bottom_section iframe {\n        height: 226px;\n      }\n    }\n  }\n\n  &.map6_container {\n    display: flex;\n    flex-direction: column;\n\n    &.map6_container > .top_section {\n      display: flex;\n      flex-direction: column;\n      flex: 0;\n      justify-content: center;\n      align-items: center;\n      width: 100%;\n      gap: 1rem;\n    }\n    &.map6_container > .bottom_section {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n    }\n    &.map6_container > .top_section > h1 {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: center;\n      width: 100%;\n      margin: 0;\n      color: ",
        ";\n      font-family: ",
        ";\n      text-align: ",
        ";\n      overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n      overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n    }\n    &.map6_container > .top_section > p {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: center;\n      width: 100%;\n      font-style: normal;\n      margin: 0;\n      color: ",
        ";\n      text-align: ",
        ";\n      font-family: ",
        ";\n      opacity: ",
        ";\n      overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n      overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n    }\n    &.map6_container > .bottom_section > .bottom_section_bottom {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      gap: 1rem;\n      align-self: center;\n    }\n    @media screen and (min-width: 768px) {\n      padding: 4rem 0;\n      gap: 2rem;\n      &.map6_container > .top_section {\n        padding: 0 4rem;\n      }\n      &.map6_container > .top_section > h1 {\n        font-size: ",
        ";\n        font-weight: ",
        ";\n        line-height: 3.875rem;\n      }\n      &.map6_container > .top_section > p {\n        font-size: ",
        ";\n        font-weight: ",
        ";\n        line-height: 1.75rem;\n      }\n      &.map6_container > .bottom_section {\n        gap: 4rem;\n      }\n      &.map6_container > .bottom_section iframe {\n        height: 564px;\n      }\n    }\n    @media screen and (max-width: 767px) {\n      padding: 2rem 0rem;\n      gap: 1rem;\n      &.map6_container > .top_section {\n        padding: 0 1rem;\n      }\n      &.map6_container > .top_section > h1 {\n        font-size: 1.5rem;\n        line-height: normal;\n      }\n      &.map6_container > .top_section > p {\n        font-size: 0.875rem;\n        line-height: normal;\n      }\n      &.map6_container > .bottom_section {\n        gap: 1rem;\n      }\n      &.map6_container > .bottom_section > .bottom_section_bottom {\n        width: 100%;\n        padding: 1rem;\n      }\n      &.map6_container > .bottom_section > .bottom_section_bottom button {\n        width: 100%;\n      }\n      &.map6_container > .bottom_section iframe {\n        height: 226px;\n      }\n    }\n  }\n"
    ]);
    ModernMiddleBodyLayout3_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ModernMiddleBodyLayout3Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ModernMiddleBodyLayout3Wrapper",
    componentId: "sc-cb393116-0"
})(ModernMiddleBodyLayout3_styles_templateObject(), function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontFamily) || "Arial";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.textAlign) || "center";
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.textAlign) || "center";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontFamily) || "Arial";
}, utils_common/* BODY_COLOR_OPACITY */.ur, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontSize) || "3.25rem";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontWeight) || "500";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontSize) || "1.25rem";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontWeight) || "400";
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontFamily) || "Arial";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.textAlign) || "center";
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.textAlign) || "center";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontFamily) || "Arial";
}, utils_common/* BODY_COLOR_OPACITY */.ur, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontSize) || "3.25rem";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontWeight) || "500";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontSize) || "1.25rem";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontWeight) || "400";
});

;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/MiddleBody/MiddleBody_Maps/Layout/ModernMiddleBodyLayout3/ModernMiddleBodyLayout3.js








var ModernMiddleBodyLayout3 = function(props) {
    var ref, ref1, ref2, ref3, ref4;
    var middleBodyMapState = props.middleBodyMapState, propStyle = props.propStyle, mapLatLong = props.mapLatLong;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModernMiddleBodyLayout3Wrapper, {
        className: "map".concat(middleBodyMapState === null || middleBodyMapState === void 0 ? void 0 : (ref = middleBodyMapState.mapData) === null || ref === void 0 ? void 0 : ref.mapType, "_container"),
        themeStyle: propStyle,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "top_section",
                children: [
                    (middleBodyMapState === null || middleBodyMapState === void 0 ? void 0 : (ref1 = middleBodyMapState.heading) === null || ref1 === void 0 ? void 0 : ref1.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        headingData: middleBodyMapState === null || middleBodyMapState === void 0 ? void 0 : middleBodyMapState.heading
                    }),
                    (middleBodyMapState === null || middleBodyMapState === void 0 ? void 0 : (ref2 = middleBodyMapState.description) === null || ref2 === void 0 ? void 0 : ref2.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Description/* default */.Z, {
                        descriptionData: middleBodyMapState === null || middleBodyMapState === void 0 ? void 0 : middleBodyMapState.description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bottom_section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleBody_Maps_RenderMap, (0,_object_spread/* default */.Z)({}, mapLatLong)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bottom_section_bottom",
                        children: middleBodyMapState === null || middleBodyMapState === void 0 ? void 0 : (ref3 = middleBodyMapState.button) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.content) === null || ref4 === void 0 ? void 0 : ref4.map(function(btnData, idx) {
                            var ref, ref1;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                type: middleBodyMapState === null || middleBodyMapState === void 0 ? void 0 : (ref = middleBodyMapState.button) === null || ref === void 0 ? void 0 : ref.type,
                                btnData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, btnData), {
                                    actions: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, btnData === null || btnData === void 0 ? void 0 : btnData.actions), {
                                        handler: middleBodyMapState === null || middleBodyMapState === void 0 ? void 0 : (ref1 = middleBodyMapState.mapData) === null || ref1 === void 0 ? void 0 : ref1.url
                                    })
                                }),
                                primaryButton: propStyle === null || propStyle === void 0 ? void 0 : propStyle.buttonPrimary,
                                secondaryButton: propStyle === null || propStyle === void 0 ? void 0 : propStyle.buttonSecondary
                            }, (btnData === null || btnData === void 0 ? void 0 : btnData.id) || idx);
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/MiddleBody/MiddleBody_Maps/ModernMiddleBodyMaps.js











function ModernMiddleBodyMaps(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var ref8 = (0,react.useState)((0,common/* transformWidgetProps */.Ak)(props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : ref.children)), middleBodyMapState = ref8[0], setMiddleBodyMapState = ref8[1];
    var ref9 = (0,react.useState)((0,utils_common/* extractLatLngFromGoogleMapsLink */.bj)((middleBodyMapState === null || middleBodyMapState === void 0 ? void 0 : (ref1 = middleBodyMapState.mapData) === null || ref1 === void 0 ? void 0 : ref1.url) || utils_common/* MAP_URL */.O_)), mapLatLong = ref9[0], setMapLatLong = ref9[1];
    var ref10 = (0,react.useState)({
        config: {
            bannerAspectRatio: {
                desktop: 768,
                mobile: 768
            },
            rotationSpeed: 3
        }
    }), styleConfig = ref10[0];
    var storeData = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var widgetData = (0,es/* useSelector */.v9)(function(state) {
        return {
            widgetData: state.widgetsReducer
        };
    }).widgetData;
    var ref11 = (0,react.useState)(storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.theme) === null || ref2 === void 0 ? void 0 : ref2.style_template), propStyle = ref11[0], setPropStyle = ref11[1];
    (0,react.useEffect)(function() {
        var ref;
        if (props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : ref.children) {
            var ref1;
            setMiddleBodyMapState((0,common/* transformWidgetProps */.Ak)(props === null || props === void 0 ? void 0 : (ref1 = props.config) === null || ref1 === void 0 ? void 0 : ref1.children));
        }
    }, [
        props === null || props === void 0 ? void 0 : (ref3 = props.config) === null || ref3 === void 0 ? void 0 : ref3.children
    ]);
    (0,react.useEffect)(function() {
        if (widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate) {
            setPropStyle((0,getStylesConfig/* getStyleForProps */.dn)(widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate));
        } else {
            var ref;
            setPropStyle((0,getStylesConfig/* getStyleForProps */.dn)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.style_template));
        }
    }, [
        widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate,
        storeData === null || storeData === void 0 ? void 0 : (ref4 = storeData.theme) === null || ref4 === void 0 ? void 0 : ref4.style_template
    ]);
    var renderMiddleBodyType = function(middleBodyData) {
        var ref;
        switch(middleBodyData === null || middleBodyData === void 0 ? void 0 : (ref = middleBodyData.mapData) === null || ref === void 0 ? void 0 : ref.mapType){
            case 1:
            case 4:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyLayout1, {
                    middleBodyMapState: middleBodyData,
                    mapLatLong: mapLatLong,
                    propStyle: propStyle
                });
            case 2:
            case 3:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyLayout2, {
                    middleBodyMapState: middleBodyData,
                    mapLatLong: mapLatLong,
                    propStyle: propStyle
                });
            case 5:
            case 6:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyLayout3, {
                    middleBodyMapState: middleBodyData,
                    mapLatLong: mapLatLong,
                    propStyle: propStyle
                });
        }
    };
    (0,react.useEffect)(function() {
        var ref;
        setMapLatLong((0,utils_common/* extractLatLngFromGoogleMapsLink */.bj)((middleBodyMapState === null || middleBodyMapState === void 0 ? void 0 : (ref = middleBodyMapState.mapData) === null || ref === void 0 ? void 0 : ref.url) || utils_common/* MAP_URL */.O_));
    }, [
        middleBodyMapState === null || middleBodyMapState === void 0 ? void 0 : middleBodyMapState.mapData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MapMiddleBodyParentContainer, {
        id: "MT__MIDDLEBODYMAP1",
        styleConfig: styleConfig === null || styleConfig === void 0 ? void 0 : styleConfig.config,
        propsBackground: middleBodyMapState === null || middleBodyMapState === void 0 ? void 0 : (ref5 = middleBodyMapState.media) === null || ref5 === void 0 ? void 0 : ref5.background,
        themeBackground: propStyle === null || propStyle === void 0 ? void 0 : propStyle.backgroundColor,
        className: "modern_theme_middlebody_map bg_type_".concat(middleBodyMapState === null || middleBodyMapState === void 0 ? void 0 : (ref6 = middleBodyMapState.media) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.background) === null || ref7 === void 0 ? void 0 : ref7.type),
        children: renderMiddleBodyType(middleBodyMapState)
    });
}
/* harmony default export */ var MiddleBody_Maps_ModernMiddleBodyMaps = (ModernMiddleBodyMaps);


/***/ }),

/***/ 448863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ getGoogleMapUrl; }
/* harmony export */ });
var getGoogleMapUrl = function(latitude, longitude) {
    return "https://www.google.com/maps/embed/v1/place?key=".concat("AIzaSyAVC1rp28LPP-kwCwVPZpZEt5LqLNYXVS8", "&q=").concat(latitude, ",").concat(longitude);
};


/***/ })

}]);